module.exports = __webpack_public_path__ + "static/media/sign-out.bfc77c68.svg";